import React from 'react';
import { ArrowRight } from 'lucide-react';

const CTABanner = ({ onGetStarted }) => {
  return (
    <div className="py-24 bg-background" data-testid="cta-section">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl sm:text-5xl font-bold text-foreground mb-6 leading-tight">
          Start building on
          <br />
          <span className="bg-gradient-to-r from-blue-400 via-cyan-400 to-purple-400 bg-clip-text text-transparent">
            SuperTool AI
          </span>
          {' '}today
        </h2>
        <p className="text-muted-foreground text-lg mb-10 max-w-2xl mx-auto">
          Join thousands of builders who are shipping apps faster with AI.
          No credit card required to start.
        </p>
        <button
          onClick={onGetStarted}
          className="inline-flex items-center gap-3 bg-white text-[#000000] px-8 py-4 rounded-full font-bold text-lg hover:bg-slate-100 transition-all shadow-xl shadow-white/10 hover:scale-105"
          data-testid="cta-get-started"
        >
          Get Started for Free
          <ArrowRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default CTABanner;
